<template>
    <div>
        <!-- section-考试类别 -->
        <section class="section-grade-type section" style="padding-top: 0;">
            <div class="container">
                <div class="exam-introduce-box intro">
                    <h3 class="heading-tertiary">TDA-G11介绍</h3>
                    <div class="exam-introduce color-area-one">
                        <div class="exam-introduce-title">考试定位</div>
                        <div class="exam-introduce-text">
                            TDA-G11
                            聚焦高中发展关键期，是全面评估学生学科能力发展水平与高考适应程度的综合性诊断测试，通过精准识别学科优势与薄弱知识点，帮助学生优化学习策略，为高三冲刺奠定基础并明确努力方向。
                        </div>
                    </div>
                    <div class="exam-introduce color-area-two">
                        <div class="exam-introduce-title">考试目的</div>
                        <div class="exam-introduce-text">旨在检验高一阶段知识和能力掌握程度，并让学生体会高考考查形式，帮助中学和学生提前在教学和学习上做好高考衔接。</div>
                    </div>
                </div>
                <div class="exam-introduce-box intro">
                    <h3 class="heading-tertiary">基本信息</h3>
                    <div class="exam-introduce-grid">
                        <div class="exam-introduce color-area-one">
                            <div class="exam-introduce-list">
                                <span>面向群体：</span>高二学生
                            </div>
                            <div class="exam-introduce-list">
                                <span>报名方式：</span>仅支持中学为单位报名
                            </div>
                            <div class="exam-introduce-list">
                                <span>考试形式：</span>线上机考、线下纸笔
                            </div>
                            <div class="exam-introduce-list">
                                <span>科目设置：</span>语文、数学、英语、物理、化学、生物、历史、地理、政治
                            </div>
                            <div class="exam-introduce-list">
                                <span>考查范围：</span>基于普通高中课程方案和各个学科课程标准及各地高一阶段普遍的教学进度归纳的统一知识点和能力框架
                            </div>
                        </div>
                        <div class="exam-introduce color-area-two">
                            <div class="exam-introduce-list">
                                <span>数据服务</span>
                            </div>
                            <div class="exam-introduce-list">
                                <span>中学：</span>数据型试题讲义(年级版和班级版)、成绩数据表(总分表(年级版)、总分表(班级版)、学科小题分表(年级版)、学科小题分表(班级版))、中学综合分析报告(年级版)、中学综合分析报告(班级版)、中学学科分析报告(年级版)、中学学科分析报告(班级版)。
                            </div>
                            <div class="exam-introduce-list">
                                <span>学生：</span>学生基础报告、认证成绩单(仅限线上机考)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section" id="section-intro">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">TDA试题特点</span>
                    </p>
                </h2>

                <!-- TDA常规科目试题介绍 -->
                <div class="normal-subject-dev-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">01 </span>-->
                        <span class="intro-title-text">全科覆盖能力发展诊断，为学生提供学科能力评估</span>
                    </h3>
                    <div class="intro-content">
                        <div class="normal-subject-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>科目</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA-G11 适用于高二学生，旨在全面诊断学科能力发展水平。试题基于普通高中课程方案和各个学科课程标准，结合各地高一阶段普遍的教学进度，构建统一的知识点和能力评估框架，考查形式逐步贴近高考。试题难度适中且具备良好的区分度、信度和效度，帮助学生在关键发展期全面了解各学科优势与不足，为高三冲刺做好充分准备。</span>
                                        <span class="paragraph">命题专家团队是高质量命题的基本保障，拥有近 200 名成员，具备十年以上教学经验，五届以上高三教学经验，并参与过多次省、市、区级大规模考试原创命题工作。</span>
                                    </p>
                                    <div class="subject-resource">
                                        <p class="tips">
                                            *点击按钮直接下载科目样卷或扫描二维码购买历史真题
                                        </p>
                                        <a
                                                href="https://www.cssat.cn/example/TDA-G11科目样卷.zip"
                                                class="btn btn--full btn--download btn--link"
                                        >
                                            <span>下载科目样卷</span>
                                            <i
                                                    class="ph-bold ph-download-simple icon--download"
                                            ></i>
                                        </a>
                                        <img
                                                class="subject-excercise-qrcode"
                                                src="../../assets/img/tda-dev/subject-excercise-qrcode.png"
                                                alt="历史试卷购买网页二维码"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">高考诊断试题特点</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">价值引领</p>
                                        <p class="service-feature-text">
                                            试题体现正确的政治方向和价值取向，引导学生形成正确的世界观、人生观和价值观
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考查全面</p>
                                        <p class="service-feature-text">
                                            试题内容符合新高考趋势，对学生学科素养、关键能力和必备知识进行全面考查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">科学性和时代性</p>
                                        <p class="service-feature-text">
                                            试题结合当前社会、科技、文化发展，考查对新知识和技能的掌握和应用能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">基础性和综合性</p>
                                        <p class="service-feature-text">
                                            试题涵盖高中段基础知识，同时考查综合运用知识解决实际问题的能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">应用性和创新性</p>
                                        <p class="service-feature-text">
                                            试题中设计实际应用场景，考查学生创新能力和运用理论知识解决问题能力
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">情境设计</p>
                                        <p class="service-feature-text">
                                            试题融入生活、学习等实际情境，考查学生在具体情境中运用知识解决问题能力
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TDA加试科目试题介绍 -->
                <div class="addition-subject-dev-intro intro">
                    <div class="intro-content">
                        <div class="cbt-sectinon intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>线上机考服务</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">线上机考模式由于其更大程度保障了考试严肃性且实施更便利等特点，正被越来越多高水平大学“强基计划”及其他各类“大学校考”采用。为让考生更熟悉线上机考形式，TDA除提供线下纸笔考试形式，还提供线上机考形式。</span>
                                        <span class="paragraph">TDA线上机考遵循严肃性“大学校考”实施框架，并由于其最大程度保障了<a
                                                class="text-link text-link--cbt"
                                                href="#supplement-features-cbt"
                                        ><i class="ph ph-link text-icon"></i
                                        >评估结果可靠和有效性</a
                                        >，对于线上机考考生支持<a
                                                class="text-link text-link--cbt"
                                                href="#certification-intro"
                                        ><i class="ph ph-link text-icon"></i>认证成绩单申请</a
                                        >。
                      </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">高严肃性考试实施</span>
                    </p>
                </h2>

                <!-- 成绩保障介绍 -->
                <div class="implement-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">03 </span>-->
                        <span class="intro-title-text">高严肃性考试实施标准，保障评估结果可信、有效</span>
                    </h3>
                    <div class="intro-content">
                        <div class="procedure-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>高严肃性标准化考试实施</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">TDA采用高严肃性考试实施标准，通过对内标准化保障机制、对外标准化实施指引、信息技术、人工智能等多种手段，系统性保障考试试题质量、考试安全性、稳定性、公平性和数据可靠性，从而让评估结果具备更高可信度和有效性。</span>
                                    </p>
                                </div>
                            </div>
                            <div class="service-features">
                                <p class="service-features-title">标准化考试服务保障</p>
                                <div class="service-feature-cards">
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题质量保障</p>
                                        <p class="service-feature-text">
                                            题目命制严格遵循"命、审、校(初)、排、校(终)"流程，分工明确，且试题均经过严格的原创性检查
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">试题安全保障</p>
                                        <p class="service-feature-text">
                                            制题人员签订保密协议，制题全程采用"背对背"原则，且试题与答题卡均采用带密码锁的保密袋(箱)运输
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">实施质量保障</p>
                                        <p class="service-feature-text">
                                            为中学各类实施角色提供针对性的、明晰的实施指引，并采用信息化管理系统对考试全流程进行管理
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">考试公平性保障</p>
                                        <p class="service-feature-text">
                                            统一发放保密袋(箱)开锁密码和机考开考密钥确保统一开考，阅卷采用线上"联考联阅"模式
                                        </p>
                                    </div>
                                    <div class="service-feature-card">
                                        <p class="service-feature-title">数据可靠性保障</p>
                                        <p class="service-feature-text">
                                            对报名、参试、扫描等数据进行校验和确认，并对成绩进行多轮自动化检查和5‰随机抽样手工核对
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="supplement" id="supplement-features-cbt">
                            <p class="supplement-title">采用多种技术手段增强机考成绩质量</p>
                            <div class="cbt-procedure-section intro-section">
                                <div class="cbt-features service-features">
                                    <ul class="cbt-feature-list">
                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多种加密算法对机考电子化试题加密</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>采用多层加密进行数据安全传输防攻击措施</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--safe"
                                            >安全性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考全程实时监控，确保考试过程可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考系统自动屏蔽与考试无关的应用程序</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>机考软件锁屏、支持自动抓取切屏画面和预警</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--fair"
                                            >公平性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>答案多途径回收、一致性检查兼防篡改校验</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>

                                        <li class="cbt-feature-list-item list-item">
                                            <span class="cbt-feature-text">
                                              <i class="ph ph-check icon--list"></i>
                                              <span>考生作答完整行为数据实时保存，考后可回溯</span>
                                            </span>
                                            <span class="cbt-feature-tag tag--realiability"
                                            >可靠性<i
                                                    class="ph ph-arrow-fat-line-up text-icon"
                                            ></i
                                            ></span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="img-box">
                                    <img
                                            class="cbt-procedure-img"
                                            src="../../assets/image/relationship.png"
                                            alt="真实的机考实施相关图片"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">认证成绩单</span>
                    </p>
                </h2>

                <!-- 认证成绩单介绍 -->
                <div class="certification-intro intro" id="certification-intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">04 </span>-->
                        <span class="intro-title-text">考试成绩认证，供学生向成绩采信方提交成绩证明</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service service--cbt">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>认证成绩单(仅限线上机考)</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            参加TDA线上机考的考生可在学生系统中申请认证成绩单。认证成绩单是TDA考试的防伪成绩证明，可向成绩采信方提交。认证成绩单分为纸质版和电子版两种，申请成功后两种形式可同时获取。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">认证成绩单</p>
                                        <p class="service-feature-text">
                                            认证成绩单是针对线上机考考生的官方成绩证明，主要体现考生成绩及各地域范围内的排名数据。纸质认证成绩单选用优质纸张、印刷清晰、包装精致。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/image/TDA/reportPaper-G11.png"
                                            alt="认证成绩单与包装示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩数据验证</p>
                                        <p class="service-feature-text">
                                            每份成绩单均设有唯一的认证二维码和认证编号，使用者可通过<a
                                                class="text-link text-link--cbt"
                                                href="https://yanzheng.cssat.cn/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                        ><i class="ph ph-link text-icon"></i>官方验证网站</a
                                        >对成绩数据进行验证，有效防伪，确保成绩数据的真实性和可靠性。
                                        </p>
                                    </div>
                                    <img
                                            class="certif-img service-feature-figure-img"
                                            src="../../assets/img/tda-cert/validation.png"
                                            alt="成绩单数据验证网站示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">试题讲义</span>
                    </p>
                </h2>

                <!-- 试题讲义介绍 -->
                <div class="handouts-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <span class="intro-title-text">试题讲义，「数据驱动+深度解析」的教学利器</span>
                    </h3>
                    <div class="intro-content">
                        <div class="certification-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>试题讲义</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            考后，考试项目组将向中学提供当次考试的试题讲义。试题讲义是深度整合了考试数据分析与题目解析的综合性教学辅助文件，用于任课老师的题目讲解。TDA 试题讲义按使用角色分为试题讲义(年级版)和试题讲义(班级版)。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="certification-features service-features">
                                <!-- 认证成绩单本身特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">试题讲义(年级版)</p>
                                        <p class="service-feature-text">旨在为学科负责人对全年级教学状况的分析提供参考。</p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/explain/explain_grade.png"
                                            alt="试题讲义(年级版)示意图"
                                    />
                                </figure>

                                <!-- 认证成绩单数据验证特点介绍 -->
                                <figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">试题讲义(班级版)</p>
                                        <p class="service-feature-text">旨在为任课老师的班级教学分析提供参考。</p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/image/explain/explain_class.png"
                                            alt="试题讲义(班级版)示意图"
                                    />
                                </figure>
                            </div>
                        </div>
                        <!--<div class="section-handouts-area">
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">01</div>
                                    <div>考试第二天发布初版讲义，高效助力次日试题讲解</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    考试第二天，考试项目组发布包含完整试题解析及客观题数据的初版讲义。方便老师次日进行试题分析与讲解，帮助学生趁热打铁，精准定位知识"漏洞"，及时查漏补缺。待阅卷工作结束后考试项目组发布完整的试题讲义，补充主观题数据，提供更全面的分析支持。
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">02</div>
                                    <div>"干扰项分析"精准识别易丢分选项，助力老师定位讲解重点</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道选择题配有选项数据表，展示各选项在班级、校级与省级的选择比例，并标注正确选项与"干扰项"。"干扰项"指容易导致学生丢分的错误选项，即根据本班学生在各选项的选择比例，筛选出的选择率较高的错误选项。
                                </div>
                                <div class="paraphrase-area">
                                    <div class="paraphrase-area-title">选项数据表元素释义：</div>
                                    <div class="paraphrase-area-list">
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">1</div>
                                            <div>表示正确选项</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">2</div>
                                            <div>表示"干扰项"（本班选择比例超过 25% 的错误选项）</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">3</div>
                                            <div>表示"未选择"</div>
                                        </div>
                                        <div class="paraphrase-area-item">
                                            <div class="title-number">4</div>
                                            <div>表示没有人选择，或选择比例为 0</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_option.png"
                                         alt="试题解析选项数据表示意图"
                                    />
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">03</div>
                                    <div>"得分率展示"直观反映各层级水平，帮助老师掌握班级相对水平</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道题的最上方显示该题在本班、本校、本省范围内的得分率，即该题在本班、本校、本省范围内考生均分与该题满分的比值。任课老师可通过这些数据直观对比本班学生在每道题上的表现与本校、本省平均水平的差距，精准了解本班学生在学科知识与能力掌握上的相对水平。
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_average.png"
                                         alt="试题解析得分率示意图"
                                    />
                                </div>
                            </div>
                            <div class="section-handouts-item">
                                <div class="section-handouts-item-title">
                                    <div class="title-number">04</div>
                                    <div>试题解析及采分点清晰详尽，全面提升老师备课效率</div>
                                </div>
                                <div class="section-handouts-item-text">
                                    每道试题均附有完整的解析、明确的采分点及其分值。这有助于老师快速锁定学生的"丢分点"，明确解题思路与方法，并进行清晰的知识点讲解提升课堂讲解与备课效率。
                                </div>
                                <div class="section-handouts-item-img">
                                    <img class="certif-img service-feature-figure-img"
                                         src="../../assets/image/explain/explain_point.png"
                                         alt="试题解析采分点示意图"
                                    />
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>
        </section>

        <!-- section-考试服务介绍 -->
        <section class="section-intro section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--features">
                    <p class="section-title">
                        <span class="section-title-text">数据报告</span>
                    </p>
                </h2>

                <!-- 数据分析报告介绍 -->
                <div class="data-intro intro">
                    <h3 class="intro-title heading-tertiary">
                        <!--<span class="intro-title-number">05 </span>-->
                        <span class="intro-title-text">分析数据详实，为教学和备考提供强指引</span>
                    </h3>
                    <div class="intro-content">
                        <div class="school-report-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>考试分析报告-中学版</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            中学考试分析报告旨在帮助参试中学根据评估结果明确教学提升方向，进而有针对性地优化教学策略。中学考试分析报告分为综合报告和分科报告。综合报告旨在让教学管理者了解本校总成绩及学科成绩整体表现，在宏观上把握教学情况。分科报告旨在让学科老师了解各学科学生的整体表现，从而明确教学方向、优化教学策略。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="school-report-features service-features">
                                <p class="service-features-title">中学报告图表介绍</p>
                                <!-- 中学报告特点1 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩表现概况</p>
                                        <p class="service-feature-text">
                                            呈现各学科平均分、标准差(系数)、平均分和优生在全国或全省范围的校级横向对比等数据，让教学管理者多角度洞察本校整体成绩表现
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-1.webp"
                                            alt="中学报告成绩表现概况示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点2 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-2.webp"
                                            alt="中学报告学科平均表现示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">学科平均表现</p>
                                        <p class="service-feature-text">
                                            呈现各学科平均分及本校平均分相对于本省考生平均分、本身优生平均分和全国优生平均分的相对位置，让教学管理者明确本校学科优劣势
                                        </p>
                                    </div>
                                </figure>

                                <!-- 中学报告特点3 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">成绩分布</p>
                                        <p class="service-feature-text">
                                            呈现“纸笔”和“机考”两类考生总成绩和各学科的成绩分布，让教学管理者直观地了解本校成绩的整体集中度和差异度，及两类考生的差异程度
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-3.webp"
                                            alt="中学报告成绩分布示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点4 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-4.webp"
                                            alt="中学报告知识点表现概况示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">知识点表现概况</p>
                                        <p class="service-feature-text">
                                            呈现各知识点本校平均得分率、考查频率、及全国和本省范围的整体或优生平均得分率，让学科老师明确学科知识点优劣势和教学重点
                                        </p>
                                    </div>
                                </figure>

                                <!-- 中学报告特点5 -->
                                <figure class="service-feature-figure--horizon">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">知识点表现对比</p>
                                        <p class="service-feature-text">
                                            通过箱型图呈现各学科知识点下本省各中学平均得分率的分布，了解本校平均得分率的相对位置，让学科老师从知识点视角了解科目优劣势
                                        </p>
                                    </div>
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-5.webp"
                                            alt="中学报告知识点表现对比示意图"
                                    />
                                </figure>

                                <!-- 中学报告特点6 -->
                                <figure
                                        class="service-feature-figure--horizon horizon-figure--reversed"
                                >
                                    <img
                                            class="service-feature-figure-img"
                                            src="../../assets/img/tda-data/school-report-6.webp"
                                            alt="中学报告作答时长示意图"
                                    />
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">作答时长</p>
                                        <p class="service-feature-text">
                                            呈现线上机考考生作答时在各题作答界面的停留时长(可近似看作答题时长)，让学科老师了解学生作答时长分配从而识别学生作答策略问题
                                        </p>
                                    </div>
                                </figure>
                            </div>
                        </div>
                        <div class="student-report-section intro-section">
                            <div class="service">
                                <p class="service-title">
                                    <i class="ph ph-lightbulb"></i>
                                    <span>考试分析报告-学生版</span>
                                </p>
                                <div class="service-content">
                                    <p class="service-text">
                                        <span class="paragraph">
                                            TDA向参试学生提供学生考试分析报告作为个人学习的参考，基础报告内容为学生当次测试的客观数据，包含学生在当次测试中的总成绩、单科成绩，及成绩在全国、本省、本校范围内的排名情况，并包括各科的各题型、各知识点下的数据表现。
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="student-report-features service-features student-report-features-one">
                                <figure class="service-feature-figure--vertical" style="grid-template-rows: 1fr;">
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/img/tda-data/基础报告.webp"
                                            alt="基础报告示意图"
                                    />
                                </figure>
                                <!--<figure class="service-feature-figure--vertical">
                                    <div class="service-feature-figure-desc">
                                        <p class="service-feature-title">预测报告</p>
                                        <p class="service-feature-text">
                                            预测报告内容以学生考试客观数据为基础并通过统计推断得出的推断类型数据，包括单科高考预测分和百分比排名(标测数据指标)，以及基于标测数据得出的“强基计划”入围概率
                                        </p>
                                    </div>
                                    <img
                                            class="student-report-img service-feature-figure-img"
                                            src="../../assets/img/tda-data/预测报告.webp"
                                            alt="预测报告示意图"
                                    />
                                </figure>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section-参加TDA -->
        <section class="section-procedure section">
            <div class="container">
                <h2 class="heading-secondary heading-secondary--procedure">
                    <p class="section-title">
                        <span class="section-title-text">参加诊断性测试(TDA)</span>
                    </p>
                </h2>
                <div class="section-content">
                    <h3 class="heading-tertiary">中学参试</h3>
                    <!-- TDA参与全流程 -->
                    <div class="procedure-subsection">
                        <h3 class="heading-sixth heading-sixth--mb">TDA参试与服务流程</h3>
                        <div class="procedure-subsection-content subsection-content">
                            <!-- step1 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-one step-number"></i>
                                    <span>考试报名</span>
                                </p>
                                <p class="step-content">
                                    在CSSAT中学系统中导入参试学生名单信息完成考试报名。如未获得中学系统的账号和密码，可填写<a
                                        class="text-link"
                                        href="#register-subsection"
                                ><i class="ph ph-link text-icon"></i>报名申请信息</a
                                >
                                    进行网上申请或直接<a class="text-link" href="#footer"
                                ><i class="ph ph-link text-icon"></i>联系考试项目组</a
                                >
                                </p>
                            </div>

                            <!-- step2 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-two step-number"></i>考前准备
                                </p>
                                <p class="step-content">
                                    接收考试项目组寄送的试卷、答题卡及其他相关物料，并阅读各角色考试实施指引熟悉相关实施操作。如参与线上机考，需提前按要求完成监控布置和考试软件准备
                                </p>
                            </div>

                            <!-- step3 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-three step-number"></i
                                    >考中实施
                                </p>
                                <p class="step-content">
                                    考前及时接收保密袋(箱)开锁密码、开袋(箱)获取并分发试卷和答题卡。如参加机考，需获取并公布开考密钥。考中认真监考，如遇异常与考试项目组沟通解决
                                </p>
                            </div>

                            <!-- step4 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-four step-number"></i>数据回传
                                </p>
                                <p class="step-content">
                                    考试结束后配合考试项目组完成答题卡扫描与上传。如参加机考，配合考试项目组完成考生机考作答数据回收，并在规定时间内向考试项目组上传本地监控录制视频文件
                                </p>
                            </div>

                            <!-- step5 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-five step-number"></i>线上阅卷
                                </p>
                                <p class="step-content">
                                    及时接收考试项目组分发的阅卷参考答案与评分标准、各科阅卷账号和密码，并在考后及时完成线上阅卷。如对答案有疑义，及时向考试项目组写邮件告知
                                </p>
                            </div>

                            <!-- step6 -->
                            <div class="step">
                                <p class="step-title">
                                    <i class="ph ph-number-square-six step-number"></i
                                    >成绩与报告获取
                                </p>
                                <p class="step-content">
                                    考试当日内中学可获得客观题数据分析及完整试题解析。阅卷结束后当周获得成绩明细表格、各类分析报告。学生可获得考试分析报告或申请认证成绩单
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- TDA参与全流程 -->
                    <div class="register-subsection" id="register-subsection">
                        <div class="register-text-box">
                            <h2 class="heading-secondary">提交申请表进行考试报名申请</h2>
                            <p class="register-text">
                                TDA报名需在CSSAT中学系统中完成。如还未有系统账号和密码，请先填写并提交以下申请表或直接联系考试项目组获取。提交申请后，考试项目组会与你联系并向你提供相关账号和密码。如已有中学系统账号和密码，请直接<a
                                    class="text-link"
                                    href="#"
                            ><i class="ph ph-link text-icon"></i>进入中学系统进行报名</a
                            >。
                            </p>
                            <div class="register-form" name="sign-up">
                                <!-- 中学省份筛选 -->
                                <div class="form-item">
                                    <label for="school-province">中学省份:</label>
                                    <select
                                            v-model="formData.province_id"
                                            id="school-proince-selection"
                                            name="school-proince-selection"
                                            required
                                            :class="!formData.province_id?'no-value':''"
                                            @blur="validateProvince"
                                            @change="onChangeProvince"
                                    >
                                        <option value="">请选择中学省份</option>
                                        <option v-for="(item, index) in provinceList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="provinceErr" class="input-error">{{provinceErrMsg}}</span>
                                </div>

                                <!-- 中学城市筛选 -->
                                <div class="form-item">
                                    <label for="school-city">中学城市:</label>
                                    <select
                                            v-model="formData.city_id"
                                            id="school-city-selection"
                                            name="school-city-selection"
                                            required
                                            :class="!formData.city_id?'no-value':''"
                                            @blur="validateCity"
                                    >
                                        <option value="">请选择中学城市</option>
                                        <option v-for="(item, index) in cityList"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <span v-if="cityErr" class="input-error">{{cityErrMsg}}</span>
                                </div>

                                <!-- 中学名称筛选 -->
                                <div class="form-item">
                                    <label for="school">中学名称:</label>
                                    <input
                                            v-model="formData.school_name"
                                            id="school-selection"
                                            type="text"
                                            placeholder="请填写真实中学名称"
                                            name="school-selection"
                                            required
                                            @blur="validateSchool"
                                    />
                                    <span v-if="schoolErr" class="input-error">{{schoolErrMsg}}</span>
                                </div>

                                <!-- 联系人姓名 -->
                                <div class="form-item">
                                    <label for="name">联系人姓名:</label>
                                    <input
                                            v-model="formData.contact_person"
                                            id="input-name"
                                            type="text"
                                            placeholder="请填写真实联系人"
                                            name="input-email"
                                            required
                                            @blur="validatePerson"
                                    />
                                    <span v-if="contactPersonErr" class="input-error">{{contactPersonErrMsg}}</span>
                                </div>

                                <!-- 联系人邮箱 -->
                                <div class="form-item">
                                    <label for="email">联系邮箱:</label>
                                    <input
                                            v-model="formData.email"
                                            id="input-email"
                                            type="email"
                                            placeholder="请填写常用邮箱"
                                            name="input-email"
                                            required
                                            @blur="validateEmail"
                                    />
                                    <span v-if="emailErr" class="input-error">{{emailErrMsg}}</span>
                                </div>

                                <!-- 联系人电话 -->
                                <div class="form-item">
                                    <label for="phone">联系电话:</label>
                                    <input
                                            v-model="formData.contact_phone"
                                            id="input-phone"
                                            type="text"
                                            placeholder="请填写联系手机号或固话"
                                            name="input-phone"
                                            required
                                            @blur="validatePhone"
                                    />
                                    <span v-if="phoneErr" class="input-error">{{phoneErrMsg}}</span>
                                </div>

                                <button class="btn btn--form" @click="onApply()">提交申请</button>
                                <div class="register-dialog" v-if="errMsgShow">{{errMsg}}</div>
                            </div>
                        </div>
                        <div
                                class="register-img-box"
                                role="img"
                                aria-label="填写申请表的配图"
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {apply, getCityList, getProvinceList} from "@/request";

    export default {
        name: "TDA-G11",
        data() {
            return {
                loading: false,
                formData: {
                    province_id: '',
                    city_id: '',
                    school_name: '',
                    contact_person: '',
                    email: '',
                    contact_phone: '',
                    action: 'gw',
                },
                provinceErr: false,
                provinceErrMsg: '',
                cityErr: false,
                cityErrMsg: '',
                schoolErr: false,
                schoolErrMsg: '',
                contactPersonErr: false,
                contactPersonErrMsg: '',
                emailErr: false,
                emailErrMsg: '',
                phoneErr: false,
                phoneErrMsg: '',
                errMsgShow: false,
                errMsg: '',
                cityOption: {},
                provinceList: [],
                cityList: [],
            }
        },
        mounted() {
            this.getProvince();
            this.getCity();
        },
        methods: {
            // 邮箱正则
            ruleEmail(email) {
                let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                return emailRegex.test(email);
            },
            // 手机号|固话正则
            rulePhone(phone) {
                // 匹配手机号的正则
                const phoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\(?\d{3,4}\)?)\s*-?\s*(\d{3,4})\s*-?\s*(\d{4})$/;
                // 匹配固定电话的正则
                const fixedPhoneRegex = /^(\+?\d{1,4})?\s*-?\s*(\d{3,4})\s*-?\s*(\d{3,4})$/;
                return phoneRegex.test(phone) || fixedPhoneRegex.test(phone);
            },
            validateProvince() {
                if (!this.formData.province_id) {
                    this.provinceErr = true;
                    this.provinceErrMsg = '请选择中学省份！';
                    return true;
                } else {
                    this.provinceErr = false;
                    this.provinceErrMsg = '';
                    return false;
                }
            },
            validateCity() {
                if (!this.formData.city_id) {
                    this.cityErr = true;
                    this.cityErrMsg = '请选择中学城市！';
                    return true;
                } else {
                    this.cityErr = false;
                    this.cityErrMsg = '';
                    return false;
                }
            },
            validateSchool() {
                if (!this.formData.school_name) {
                    this.schoolErr = true;
                    this.schoolErrMsg = '请填写真实中学名称！';
                    return true;
                } else {
                    this.schoolErr = false;
                    this.schoolErrMsg = '';
                    return false;
                }
            },
            validatePerson() {
                if (!this.formData.contact_person) {
                    this.contactPersonErr = true;
                    this.contactPersonErrMsg = '请填写真实联系人！';
                    return true;
                } else {
                    this.contactPersonErr = false;
                    this.contactPersonErrMsg = '';
                    return false;
                }
            },
            validateEmail() {
                if (!this.formData.email) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写常用邮箱！';
                    return true;
                } else if (!this.ruleEmail(this.formData.email)) {
                    this.emailErr = true;
                    this.emailErrMsg = '请填写正确格式的邮箱！';
                    return true;
                } else {
                    this.emailErr = false;
                    this.emailErrMsg = '';
                    return false;
                }
            },
            validatePhone() {
                if (!this.formData.contact_phone) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写联系手机号或固话！';
                    return true;
                } else if (!this.rulePhone(this.formData.contact_phone)) {
                    this.phoneErr = true;
                    this.phoneErrMsg = '请填写正确格式的手机号或固话！';
                    return true;
                } else {
                    this.phoneErr = false;
                    this.phoneErrMsg = '';
                    return false;
                }
            },
            // 提交申请
            async onApply() {
                let status = false;
                if (this.validateProvince()) {
                    status = true;
                }
                if (this.validateCity()) {
                    status = true;
                }
                if (this.validateSchool()) {
                    status = true;
                }
                if (this.validatePerson()) {
                    status = true;
                }
                if (this.validateEmail()) {
                    status = true;
                }
                if (this.validatePhone()) {
                    status = true;
                }
                if (status) return false;

                if (this.loading) return false;
                this.loading = true;

                let data = await apply(this.formData);
                this.errMsg = data.message;
                this.errMsgShow = true;
                setTimeout(() => {
                    this.errMsg = '';
                    this.errMsgShow = false;
                }, 3000)
                if (data.code != 200) {
                    this.loading = false;
                    return false;
                }
                this.loading = false;
                this.formData.province_id = '';
                this.formData.city_id = '';
                this.formData.school_name = '';
                this.formData.contact_person = '';
                this.formData.email = '';
                this.formData.contact_phone = '';
            },
            onChangeProvince() {
                this.formData.city_id = '';
                this.cityList = [];
                let pId = this.formData.province_id;
                let all_city = this.cityOption;
                let city_list = [];
                for (let key in all_city) {
                    if (pId == all_city[key]['parent_id']) {
                        city_list.push(all_city[key]);
                    }
                }
                this.cityList = city_list;
            },
            async getProvince() {
                let data = await getProvinceList();
                if (data.code != 200) return;
                this.provinceList = data.list;
            },
            async getCity() {
                let data = await getCityList();
                if (data.code != 200) return;
                this.cityOption = data.list;
            },
            downloadFile(name) {
                let href = parent.window.location.origin + '/example/' + name;
                console.log(href);
                window.location.href = href;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/main--tda.css';
    @import '../../assets/css/queries--tda.css';
    @import '../../assets/scss/main--tda.scss';
    @import '../../assets/scss/queries--tda.scss';

    .form-item {
        position: relative;
    }

    .input-error {
        position: absolute;
        top: 100%;
        left: 0;
        color: #f56c6c;
        font-size: 1.1rem;
        line-height: 1;
        padding-top: 0.4rem;
    }

    .register-form {
        position: relative;
    }

    .register-dialog {
        position: absolute;
        left: 50%;
        top: 60%;
        transform: translate(-50%, -50%);
        font-size: 1.2rem;
        background-color: #000000;
        padding: 1rem 1.2rem;
        border-radius: 0.6rem;
        opacity: 0.85;
    }

</style>
